/* eslint-disable @typescript-eslint/no-unused-vars */

xplenty.controller('AuthenticationStep', [
  '$scope',
  '$translate',
  '$timeout',

  function ($scope, $translate, $timeout) {
    $scope.authenticationStep = $scope.$parent.createStep(
      'Authentication',
      'Choose authentication type',
      '<rest-api-authentication component="component" />',
    );
  },
]);
